import Link from '@/components/base/TransitionLink';

export default function Footer() {
  return (
    <footer className="tone-stone text-sm">
      <div className="shell py-12 md:py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-6">
          <Link to="/" className="font-heading font-semibold text-2xl tracking-[0.04em] cursor-pointer">MATERA</Link>
          <p className="mt-2 meta">Exterior Surface Works — The Art of Surfaces</p>
        </div>
        <nav className="md:col-span-3 md:col-start-7 flex flex-col gap-2 text-sm" aria-label="Footer">
          <span className="meta mb-1">Pages</span>
          <Link to="/" className="hover:text-accent-600 cursor-pointer">Home</Link>
          <Link to="/services" className="hover:text-accent-600 cursor-pointer">Services</Link>
          <Link to="/projects" className="hover:text-accent-600 cursor-pointer">Projects</Link>
          <Link to="/contact" className="hover:text-accent-600 cursor-pointer">Contact</Link>
        </nav>
        <div className="md:col-span-3 text-sm">
          <span className="block meta mb-3">Estimates</span>
          <Link to="/contact" className="inline-flex items-center gap-2 border-b border-foreground-950 pb-0.5 hover:text-accent-600 hover:border-accent-600 cursor-pointer whitespace-nowrap">
            Request an estimate <i className="ri-arrow-right-up-line" />
          </Link>
          <p className="mt-4 text-xs leading-relaxed text-foreground-600 max-w-[16rem]">Service availability will be confirmed based on your project location.</p>
        </div>
      </div>
      <div className="shell py-5 border-t border-foreground-950/10 flex flex-col sm:flex-row justify-between gap-2 text-xs text-foreground-600">
        <span>© 2026 MATERA Exterior Surface Works</span>
        <span>Residential exterior wall finishing &amp; restoration</span>
      </div>
    </footer>
  );
}